module.exports = __webpack_public_path__ + "img/parallax-background.3b11ce4e.jpg";